import LockIcon from "@mui/icons-material/Lock";
import { Box } from "../../components";

export const LockedIcon = () => {
  return (
    <Box
      p={1.2}
      display="flex"
      title={"This item is locked and cannot be edited or deleted by users without sufficient permission"}
      sx={{ opacity: 0.6 }}
    >
      <LockIcon />
    </Box>
  );
};
